<template>
  <div class="tab-wrap">
    <ul class="tab">
      <li class="flex-column-center" :class="{ active: curStep === 1, complete: curStep === 2 }">
        <div class="icon-wrap flex-row-center">
          <step1 class="icon-step1"></step1>
          <span class="line"></span>
        </div>
        <p class="sub-text">{{ identity ? '身份核验' : '考试须知' }}</p>
      </li>
      <li class="flex-column-center" :class="{ active: curStep === 2 }">
        <div class="icon-wrap flex-row-center">
          <step2 class="icon-step2"></step2>
          <span class="line" v-if="identity && notice"></span>
        </div>
        <p class="sub-text">{{ identity && notice ? '考试须知' : '等待进入' }}</p>
      </li>
      <li class="flex-column-center" v-if="identity && notice">
        <div class="icon-wrap flex-row-center">
          <step3 class="icon-step3"></step3>
        </div>
        <p class="sub-text">等待进入</p>
      </li>
    </ul>
  </div>
</template>

<script>
import Step1 from '@/assets/svg/identityCheck/step1.svg'
import Step2 from '@/assets/svg/identityCheck/step2.svg'
import Step3 from '@/assets/svg/identityCheck/step3.svg'
export default {
  components: {
    Step1,
    Step2,
    Step3
  },
  props: {
    curStep: {
      type: Number
    },
    needNotice: String,
    needIdentity: String
  },
  computed: {
    notice() {
      return this.needNotice === 'true'
    },
    identity() {
      return this.needIdentity === 'true'
    }
  }
}
</script>

<style lang="scss" scoped>
  .tab-wrap {
    // width: 872px;
    margin: 56px 150px;
    position: relative;
  }
  .line {
    width: 360px;
    border-top: 1px dashed #bbb;
    position: absolute;
    left: 48px;
    top: 25px;
    z-index: 1;
  }
  .tab {
    display: inline-flex;
    li {
      margin-left: 355px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .icon-wrap {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #FAFAFA;
    border: 0.5px solid rgba(0, 0, 0, 0.2);
    position: relative;
  }
  .icon-step1 {
    width: 22px;
    height: 39px;
    margin-left: 4px;
  }
  .icon-step2 {
    width: 22px;
    height: 39px;
    margin-left: 3px;
  }
  .icon-step3 {
    width: 23px;
    height: 39px;
  }
  .sub-text {
    font-weight: 400;
    margin-top: 8px;
    color: #999;
  }
  .active {
    .icon-wrap {
      background-color: #fff;
      box-shadow: 0 8px 16px 0 rgba(48,111,255,0.15);
      border: none;
    }
    /deep/ .line-stroke {
      stroke: #306FFF !important;
    }
    /deep/ .text-fill {
      fill: #306FFF !important;
    }
    /deep/ .bg-fill {
      fill: #fff !important;
    }
    .sub-text {
      color: #306FFF;
    }
  }
  .complete {
    .icon-wrap {
      background-color: #fff;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
      border: none;
    }
    /deep/ .line-stroke {
      stroke: #333 !important;
    }
    /deep/ .text-fill {
      fill: #333 !important;
    }
    /deep/ .bg-fill {
      fill: #fff !important;
    }
    .sub-text {
      color: #333;
    }
  }
</style>
